// extracted by mini-css-extract-plugin
export default {"content":"styles_content__uTtte","container":"styles_container__nFpwZ","nextPageBtn":"styles_nextPageBtn__SKbPC"};